import React, { useCallback, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import sidebarData from "./SidebarData";
//Simple bar
import SimpleBar from "simplebar-react";
// MetisMenu
import MetisMenu from "metismenujs";
import withRouter from "../../components/Common/withRouter";
import { Link } from "react-router-dom";
//i18n
import { withTranslation } from "react-i18next";
const Sidebar = (props) => {
  const ref = useRef();
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }
    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;
      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag
        const parent3 = parent2.parentElement; // li tag
        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);
  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;
      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.length && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }
        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;
        if (parent2) {
          parent2.classList.remove("mm-show");
          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");
            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };
  const activeMenu = useCallback(() => {
    const pathName = props.router.location.pathname;
    const fullPath = pathName;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu-item");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);
    for (let i = 0; i < items.length; ++i) {
      if (fullPath === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [
    props.router.location.pathname,
    activateParentDropdown,
  ]);
  useEffect(() => {
    ref.current.recalculate();
  }, []);
  useEffect(() => {
    new MetisMenu("#side-menu-item");
    activeMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    activeMenu();
  }, [activeMenu]);
  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div style={{ flex: '1', minHeight: '0' }}>
            <SimpleBar className="h-100" ref={ref}>
              <div id="sidebar-menu">
                <ul className="metismenu list-unstyled" id="side-menu-item">
                  {(sidebarData || []).map((item, key) => (
                    <React.Fragment key={key}>
                      {item.isMainMenu ? (
                        <li className="menu-title">{props.t(item.label)}</li>
                      ) : (
                        <li key={key}>
                          <Link
                            to={item.url ? item.url : "/#"}
                            className={
                              (item.issubMenubadge || item.isHasArrow)
                                ? " "
                                : "has-arrow"
                            }
                          >
                            <i
                              className={item.icon}
                              style={{ marginRight: "5px" }}
                            ></i>
                            {item.issubMenubadge && (
                              <span
                                className={
                                  "badge rounded-pill float-end " + item.bgcolor
                                }
                              >
                                {" "}
                                {item.badgeValue}{" "}
                              </span>
                            )}
                            <span>{props.t(item.label)}</span>
                          </Link>
                          {item.subItem && (
                            <ul className="sub-menu">
                              {item.subItem.map((item, key) => (
                                <li key={key}>
                                  <Link
                                    to={item.link}
                                    className={
                                      item.subMenu && "has-arrow waves-effect"
                                    }
                                  >
                                    {props.t(item.sublabel)}
                                  </Link>
                                  {item.subMenu && (
                                    <ul className="sub-menu">
                                      {item.subMenu.map((item, key) => (
                                        <li key={key}>
                                          <Link to="#">
                                            {props.t(item.title)}
                                          </Link>
                                        </li>
                                      ))}
                                    </ul>
                                  )}
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      )}
                    </React.Fragment>
                  ))}
                </ul>
              </div>
            </SimpleBar>
          </div>
          
          {/* Contact Section at bottom of sidebar */}
          <div className="sidebar-contact-section" style={{ 
            padding: '15px 15px 20px 15px',
            borderTop: '1px solid rgba(255,255,255,0.1)',
            backgroundColor: 'inherit',
            boxShadow: '0 -2px 8px rgba(0,0,0,0.1)'
          }}>
            <div style={{ 
              fontSize: '11px', 
              color: '#8492a6', 
              marginBottom: '10px',
              lineHeight: '1.3',
              textAlign: 'center'
            }}>
              Contact us for any support or query
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexWrap: 'nowrap'
            }}>
              <a 
                href="mailto:applications.mmwt@gmail.com" 
                style={{ 
                  color: '#556ee6', 
                  textDecoration: 'none', 
                  fontSize: '11px',
                  fontWeight: '500',
                  display: 'flex',
                  alignItems: 'center',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  maxWidth: '100%'
                }}
                onMouseOver={(e) => {
                  e.target.style.textDecoration = 'underline';
                  e.target.style.color = '#4f46e5';
                }}
                onMouseOut={(e) => {
                  e.target.style.textDecoration = 'none';
                  e.target.style.color = '#556ee6';
                }}
                title="applications.mmwt@gmail.com"
              >
                <i className="mdi mdi-email-outline" style={{ 
                  marginRight: '6px', 
                  fontSize: '14px',
                  flexShrink: 0
                }}></i>
                <span style={{ 
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}>
                  applications.mmwt@gmail.com
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
Sidebar.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};
export default withRouter(withTranslation()(Sidebar));